import React from "react";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function Topheader(props) {
  const navigate = useNavigate();
  const location = useLocation();

  function SendPostMessage(message) {
    console.log("message: ", message);
    window.ReactNativeWebView.postMessage(message);
  }
  function ExitPage() {
    var exitDeepLink = {
      redirectionType: "EXIT",
    };
    SendPostMessage(JSON.stringify(exitDeepLink));
  }

  useEffect(() => {
    if (!sessionStorage.getItem("rootPath")) {
      sessionStorage.setItem("rootPath", location.pathname);
    }
  });

  function historyCheckOrExit() {
    
    const oldpath = sessionStorage.getItem("rootPath");
    if (window.location.href === "/" || window.location.pathname === oldpath) {
      console.log("exit");
      console.log(window.location.href);
      ExitPage();
    } else {
      console.log("back");
      console.log(window.location.href);
      navigate(-1, { replace: false });
    }
  }

  // Change SVG color for a specific page
  const isSpecificPage = location.pathname === "/allinclub"; 
 const isSpecificPage2 = location.pathname === "/faq" || location.pathname === "/faqs" || location.pathname.includes("/faqs/") || location.pathname === "/coinsdetail"; 
  return (
    <>
      <div className="pb-btm">
        <div className={props.colorbox}>
          <div className="py-2">
            <div onClick={historyCheckOrExit} className="back-buttonsvg">
              {isSpecificPage ? (
                // Black SVG for specific page
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                  <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" fill="#A58135" />
                </svg>
              ) :
             
               (
                isSpecificPage2 ?
                // White SVG for all other pages
              
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 8 14" fill="none">
  <path d="M6.75 12.75L0.75 6.75039L6.75 0.75" stroke="#6E6E6E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                :
                 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                  <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" fill="#FFFFFF" />
                </svg>
              )}
            </div>
            {props.title}
          </div>
        </div>
      </div>
    </>
  );
}

Topheader.propTypes = {
  title: PropTypes.string,
  colorbox: PropTypes.string,
};

Topheader.defaultProps = {
  title: "PokerBaazi",
  colorbox: "blue-box",
};
